import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-regular-svg-icons'

const toHtmlId = value => value.replace(/\s+/g, '-').toLowerCase();

const AddPhoto = ({ name, uploadFile }) => {
  const handleFiles = ({ name, target }) => {
    Array.from(target.files).forEach(file => uploadFile({ file, name }))
  };

  return (
    <>
      <input
        type="file"
        id={toHtmlId(name)}
        onChange={e => handleFiles({ name, target: e.target })}
        style={{ display: 'none' }}
      />
      <label htmlFor={toHtmlId(name)}>
        {name}{' '}
        <FontAwesomeIcon icon={faPlusCircle} />
      </label>
    </>
  );
};

export default AddPhoto;
